import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui'
import { monthLabel } from './model/months'
import type { MonthKey } from './model/types'

interface AsOfPicker {
  months: MonthKey[]
  month: MonthKey
  onMonthChange: (month: MonthKey) => void
}

// "Portfolio" with its Beta pill, and the As of statement month on the right.
export const PortfolioHeading = ({ asOf }: { asOf?: AsOfPicker }) => (
  <div className="flex min-h-9 items-center justify-between gap-4 text-blue-7">
    <div className="flex items-center gap-2.5">
      <h2 className="text-lg font-semibold tracking-tight">Portfolio</h2>
      <span className="rounded-full border border-neutral-200 bg-neutral-100 px-2 py-0.5 text-xs font-medium text-neutral-600">
        Beta
      </span>
    </div>
    {asOf && asOf.months.length > 1 && (
      <div className="flex items-center gap-2.5">
        <span className="text-sm text-ink-subtle">As of</span>
        <Select value={asOf.month} onValueChange={asOf.onMonthChange}>
          <SelectTrigger className="h-9 w-[168px] cursor-pointer bg-white">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {[...asOf.months].reverse().map((month) => (
              <SelectItem key={month} value={month}>
                {monthLabel(month)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    )}
  </div>
)
